<div class="outer-container d-flex">
    <div class="left-panel col-5" *ngIf="showLeftPanel">
        <div class="heading-container d-flex">
            <img class="arrow cursor-pointer" src="./images/back-arrow.svg" (click)="backClick()">
            <div class="heading">{{'notification.notifications' | translate}}</div>
        </div>
        <div class="list-container d-flex flex-column" *ngIf="notificationList?.length" (scroll)="listScroll($event)">
            <div *ngFor="let notification of notificationList;let ind = index" class="list-item d-flex flex-column">
                <div class="date">{{formatDate(notification.dateTime)}}</div>
                <div *ngFor="let details of notification.notifications;let i = index"
                    class="details d-flex flex-column cursor-pointer"
                    [ngClass]="{'details-active':details.id == selectedNotification?.id && !isMobile}"
                    (click)="notificationClick(ind,i)">
                    <div class="heading-date-container d-flex justify-content-between">
                        <div class="heading d-flex">{{details.title}} <div class="unread" *ngIf="!details.isRead"></div>
                        </div>
                        <div class="time">{{details.notificationTime | date : 'hh:mma'}}</div>
                    </div>
                    <div class="content">{{details.body}}</div>
                </div>
            </div>
        </div>
        <div class="list-container d-flex no-data" *ngIf="!notificationList?.length">
            <img class="no-promotion-img" src="./images/no-notification.svg">
            {{'notification.noNotification' | translate}}
        </div>
    </div>
    <div class="right-panel col-7 d-flex flex-column" *ngIf="showRightPanel">
        <ng-container *ngIf="selectedNotification && notificationList?.length">
            <div class="heading-date-container d-flex justify-content-between">
                <div class="heading">
                    <img class="arrow cursor-pointer" *ngIf="isMobile" src="./images/back-arrow.svg"
                        (click)="backClick()">
                    {{selectedNotification?.title}}
                </div>
                <div class="date">{{selectedNotification?.notificationTime | date : 'dd MMMM yyyy hh:mma'}}</div>
            </div>
            <div class="content-container d-flex flex-column">
                <img class="notification-img" [src]="'data:image/png;base64,' + selectedNotification?.imageBase64"
                    *ngIf="selectedNotification?.imageBase64">
                <div class="content">{{selectedNotification?.body}}</div>
                <div class="link-container" *ngIf="selectedNotification?.link">{{'notification.learnMore' | translate}}&nbsp;<span class="link" (click)="onLinkClick()">{{selectedNotification?.link}}</span></div>
            </div>
        </ng-container>
        <ng-container *ngIf="!selectedNotification || !notificationList?.length">
            <div class="no-data select-notification-item">
                <img class="no-promotion-img" src="./images/select-notification-item.svg">
                {{'notification.selectNotificationItem' | translate}}
            </div>
        </ng-container>
    </div>
</div>